// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"AssignChecklist_AssignChecklist__Osrmp","modalBody":"AssignChecklist_modalBody__UCB67","formControl":"AssignChecklist_formControl__enrkD"};